module.exports = __webpack_public_path__ + "img/survey.f414f708.png";